export enum FileAreas
{
    CLINICAL_REGISTRY = 'clinical-registry'
}
